import { Dialog } from "@material-ui/core";
import { useMemo, useState } from "react";
import { DebounceInput } from "react-debounce-input";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { CloseIcon, DropdownIcon } from "../../../../assets/Icons";
import { offlineFlywire } from "../../../../store";
import { receivingCountryData } from "../../../../utils";
import Button from "../../../../components/ui/Button";

export const OfflineFlywireRemittancePage = () => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState<number>();
  const [reference, setReference] = useState<string>("");
  const [isModalOpen, setIsModalOpen] = useState<string>("");
  const [offlineFlywireData, setOfflineFlywireData] = useRecoilState(offlineFlywire);
  const [currencyName, setCurrencyName] = useState<string>("USD");
  const [disabled, setDisabled] = useState<boolean>(true);

  useMemo(() => {
    if (amount) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  }, [amount]);

  return (
    <div>
      <div id="wrapper" className="flex flex-col items-center w-full">
        <div
          onClick={() => navigate("/home")}
          className="p-5 ml-[1420px] mt-2 hover:scale-150 transition-all cursor-pointer"
        >
          <CloseIcon />
        </div>
        <div className="w-[800px] border space-y-5 border-black rounded-xl mt-36 flex flex-col items-center">
          <span className="text-[35px] font-bold font-ssp">Amount</span>
          <span className="">Please enter the details below</span>
          <div id="payBox" className="flex flex-col items-center p-6 border border-black">
            <div id="amount" className="flex flex-col justify-center">
              <span className="text-[19px] font-semibold">They Receive *</span>
              <div className="flex w-full my-3">
                <DebounceInput
                  minLength={2}
                  className="w-full px-5 text-lg bg-blue-100 outline-none rounded-l-md"
                  name="recievingAmount"
                  type="number"
                  value={amount}
                  //   value={recievingAmount}
                  debounceTimeout={1000}
                  //   disabled={recieveDisabled}
                  onChange={(e: any) => {
                    setAmount(e.target.value);
                    setOfflineFlywireData({ ...offlineFlywireData, amount: e.target.value });
                  }}
                />
                <div
                  onClick={() => setIsModalOpen("recieve")}
                  className="flex py-[17px] w-[155px] space-x-4 border rounded-md cursor-pointer"
                >
                  <img
                    src={`/images/png/${currencyName}.png`}
                    alt="receiving-country-image"
                    className="rounded-[200px] w-7 h-7 ml-3"
                  />
                  <span className="bg-white text-[19px] space-x-2 flex items-center">
                    <span className="-ml-2">{currencyName}</span>
                    <DropdownIcon />
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-col w-full mt-5">
              <span className="text-[19px] font-semibold">Reference</span>
              <div className="mt-3">
                <input
                  value={reference}
                  onChange={(e) => {
                    setReference(e.target.value);
                    setOfflineFlywireData({ ...offlineFlywireData, reference: e.target.value });
                  }}
                  placeholder="Enter Reference"
                  className="w-full px-6 py-3 bg-blue-100 border rounded"
                  autoComplete="off"
                  pattern="[a-zA-Z0-9 ]{1,}"
                />
              </div>
            </div>
            {/* <button
              onClick={() => {
                navigate("/3/remitter");
                setOfflineFlywireData({
                  ...offlineFlywireData,
                  reference: reference,
                });
              }}
              disabled={disabled}
              className={clsx(
                "px-10 py-3 mt-20 font-bold text-white transition-all rounded bg-primary hover:bg-white hover:text-primary hover:border-2 hover:border-primary",
                disabled ? "cursor-not-allowed" :"",
              )}
            >
              Next
            </button> */}
            <div id="submit" className="flex justify-center">
              <Button
                bgColor={disabled ? "bg-gray-300" : "bg-primary-1050"}
                fontStyle={{
                  fontFamily: "font-roboto",
                  fontSize: "text-base",
                  fontWeight: "font-bold",
                  fontColor: "text-white",
                }}
                borderStyle={{
                  borderRadius: "rounded",
                }}
                onClickHandler={() => {
                  navigate("/3/remitter");
                  setOfflineFlywireData({
                    ...offlineFlywireData,
                    reference: reference,
                  });
                }}
                className={
                  "flex justify-center py-4 mt-6 ml-5 px-14 hover:scale-105 transition-all"
                }
                disabled={disabled}
              >
                Next
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Dialog open={isModalOpen === "recieve"} onClose={() => setIsModalOpen("")}>
        <div className="px-8 py-3 font-bold text-white bg-primary">Select Destination Currency</div>
        <div className="pt-4 px-7 lg:px-9">
          <div className="h-12 lg:border-none w-[372px] lg:w-[404px] mb-9"></div>
          <div className="lg:mx-[68px] -mt-20">
            {receivingCountryData.map((data, index) => {
              return (
                <div
                  className="flex items-center justify-between w-full py-6 border-b cursor-pointer lg:mb-11 lg:border-none lg:py-0 border-grey-1000"
                  key={index}
                  onClick={() => {
                    setCurrencyName(data.currencyName);
                    setOfflineFlywireData({
                      ...offlineFlywireData,
                      currency: data.currencyName ? data.currencyName : "USD",
                    });
                    setIsModalOpen("");
                  }}
                >
                  <div className="mr-8 text-xl font-normal text-primary-650">
                    {data.currencyName}
                  </div>
                  <div className="flex items-center w-2/6">
                    <div className="flex items-center justify-center w-8 h-8 mr-5">
                      <img
                        src={`/images/png/${data.currencyName}.png`}
                        alt="country-image"
                        className="rounded-[200px] w-full h-full"
                      />
                    </div>
                    <div className="text-xl font-bold text-left text-primary-650 justify-items-start">
                      {data.currencyName}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </Dialog>
    </div>
  );
};
